import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const PasswordHiddenIcon = (props: SvgProps) => <Svg
  width='24'
  height='24'
  viewBox='0 0 24 24'
  fill='none'
  {...props}
>
  <Path d='M4 20L20 4M22 12C22 12 17.5286 18 12 18C6.47143 18 2 12 2 12C2 12 6.47143 6 12 6C17.5286 6 22 12 22 12ZM12 9C11.4349 9 10.8825 9.17595 10.4127 9.50559C9.9428 9.83524 9.57659 10.3038 9.36034 10.8519C9.14409 11.4001 9.08751 12.0033 9.19776 12.5853C9.308 13.1672 9.58012 13.7018 9.9797 14.1213C10.3793 14.5409 10.8884 14.8266 11.4426 14.9424C11.9968 15.0581 12.5713 14.9987 13.0934 14.7716C13.6155 14.5446 14.0617 14.1601 14.3756 13.6667C14.6896 13.1734 14.8571 12.5933 14.8571 12C14.8571 11.2044 14.5561 10.4413 14.0203 9.87868C13.4845 9.31607 12.7578 9 12 9Z'
    stroke='#121B23'
    strokeWidth='1.5'
    strokeLinecap='round'
    strokeLinejoin='round' />
</Svg>;

export default PasswordHiddenIcon;
